import * as React from 'react'
import {fromMaybe} from '@freckle/maybe'

type Props = {
  name: string
  value: React.ReactNode | undefined | null
}

// Every read-only field in this modal snaps to the same four-column measure:
// the Teacher grids run four across, and the School and District blocks take
// two columns each.
export const FIELD_GRID = 'grid grid-cols-4 gap-x-6 gap-y-4'
export const FIELD_GRID_HALF = 'grid grid-cols-2 gap-x-6 gap-y-4'

// Three levels, each separated by case and color rather than by size: group
// headings are sentence case over a rule, sub-headings are uppercase and dark,
// field labels are uppercase and muted.
export const SUB_HEADING = 'text-xs font-semibold uppercase tracking-widest text-heading mb-2'

// The shared LabelWithValue reserves a fixed 160px gutter for the label beside
// the value, so it fits one field per row. Stacking the label is what lets
// these ~23 fields run four across.
export function Field({name, value}: Props): React.ReactElement {
  return (
    <div className="min-w-0">
      <div className="text-xs font-semibold uppercase tracking-wide text-muted-text">{name}</div>
      <div className="text-sm leading-5 text-body break-words">
        {fromMaybe(() => 'None', value)}
      </div>
    </div>
  )
}
